import store from '../store';
import {setMode} from '../reducers/viewReducer';
import {isKioskCustomerSelector} from '../selectors/userSelectors';
import {logOff} from '../reducers/userReducer';
import {kioskModeType} from '../config/const';
import * as uri from '../config/uri';
 /**
 * Determines kiosk mode and dispatches it to state
 * @returns {*}
 */
export const detectAndSetMode = (path) => {
  const kioskModeResponse = {
    kioskMode: kioskModeType.ONLINE_MENU,
    isKioskMode: false
  };
   if (path.indexOf(kioskModeType.SELF_SERVICE_KIOSK) > -1) {
    kioskModeResponse.isKioskMode = true;
    kioskModeResponse.kioskMode = kioskModeType.SELF_SERVICE_KIOSK;
    store.dispatch(setMode(kioskModeResponse));
  } else if (path.indexOf(kioskModeType.PAYMENT_KIOSK) > -1) {
    kioskModeResponse.isKioskMode = true;
    kioskModeResponse.kioskMode = kioskModeType.PAYMENT_KIOSK;
    store.dispatch(setMode(kioskModeResponse));
  } else if (path.indexOf(kioskModeType.DPOS) > -1) {
    kioskModeResponse.isKioskMode = true;
    kioskModeResponse.kioskMode = kioskModeType.DPOS;
    store.dispatch(setMode(kioskModeResponse));
  } else if (path.indexOf(kioskModeType.MAIN_BOARD) > -1) {
    kioskModeResponse.isKioskMode = true;
    kioskModeResponse.kioskMode = kioskModeType.MAIN_BOARD;
    store.dispatch(setMode(kioskModeResponse));
  } else {
    store.dispatch(setMode(kioskModeResponse));
    const isKioskCustomer = isKioskCustomerSelector(store.getState());
    if (isKioskCustomer) {
      store.dispatch(logOff());
    }
  }

  return kioskModeResponse;
};

 export const getKioskModeUri = kioskMode => {
  switch (kioskMode) {
  case kioskModeType.SELF_SERVICE_KIOSK:
    return uri.selfServiceKioskModePageUri;
  case kioskModeType.PAYMENT_KIOSK:
    return uri.kioskRootPageUri;
  case kioskModeType.DPOS:
    return uri.dposRootPageUri;
  case kioskModeType.MAIN_BOARD:
    return uri.mainBoardModePageUri;
  case kioskModeType.ONLINE_MENU:
    return uri.onlineMenuPageUri;
  default:
    console.error('ecomm mode undefined')
    return '/';
  }
};

export const isKioskWithPurchasing = (kioskMode) => {
 return kioskMode === kioskModeType.SELF_SERVICE_KIOSK || kioskMode === kioskModeType.PAYMENT_KIOSK || kioskMode === kioskModeType.DPOS
}

export const isKioskWithStartingUpPopUp = (kioskMode) => {
  return kioskMode === kioskModeType.SELF_SERVICE_KIOSK
 }
 export const isPaymentKiosk = (kioskMode) => {
  return kioskMode === kioskModeType.PAYMENT_KIOSK
 }
 export const isPaymentButtons = (kioskMode) => {
  return kioskMode === kioskModeType.PAYMENT_KIOSK
 }


// WEBPACK FOOTER //
// ./src/services/mode.js